/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useContext } from 'react'
import { Form, Formik } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import * as Yup from 'yup'
import { validateMessages, ROUTE_REGISTER, ROUTE_LOGIN_SUCCESS } from '../constants'
import FormInput from './input'
import _ from 'lodash'
import { useTranslation, Trans } from 'react-i18next'
import axios from 'axios'
import { toast } from 'react-toastify'
import moment from 'moment'
import cookie from 'react-cookies'
import Social from './social'
import qs from 'query-string'
import TagManager from 'react-gtm-module'
import { UserContext } from '../context/UserContext'

const emailSchema = (messages) => Yup.object().shape({
  email: Yup.string().required(messages.required)
})

const passwordSchema = (messages) => Yup.object().shape({
  password: Yup.string().required(messages.required)
})

const LoginForm = (props) => {
  const history = useHistory()
  const location = useLocation()
  const { t } = useTranslation('translation', { useSuspense: false })
  const [messages, setMessages] = useState({})
  const [step, setStep] = useState(0)
  const [from] = useState(qs.parse(location.search).from)
  const [forgotPasswordClicked, setforgotPasswordClicked] = useState(false)
  const { setFields } = useContext(UserContext)
  const incrementStep = () => {
    setStep(step + 1)
  }
  const decrementStep = () => {
    setStep(step - 1)
  }
  useEffect(() => {
    _.map(validateMessages, (item) => {
      messages[item] = t(item)
    })
    setMessages(messages)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOnSuccess = (data) => {
    setFields(data)
    history.push(from ? `${ROUTE_REGISTER}?from=${encodeURIComponent(from)}` : `${ROUTE_REGISTER}`)
  }

  const handleClickForgotPassword = async (data) => {
    try {
      await axios.post(`${process.env.REACT_APP_API_PATH}/auth/forgotpassword`, {
        email: userLogged.email,
      })
      toast.success(t('forgotPasswordSuccess'))
      setforgotPasswordClicked(true);
    } catch (e) {
      toast.error(t('forgotPasswordFail'))
    }
  }

  const [userLogged, setUserLogged] = useState({})
  return (
    <div className='p-6 w-full'>
      {step === 0 && (
        <>
          <Social handleOnSuccess={handleOnSuccess} />
          <Formik
            initialValues={{
              email: ''
            }}
            onSubmit={async (values) => {
              try {
                const { data: res } = await axios.post(`${process.env.REACT_APP_API_PATH}/auth/check`, {
                  ...values,
                  type: 'email'
                })
                window.user = res.data
                incrementStep()
                setUserLogged({
                  ...values
                })
              } catch (e) {
                toast.error(t(e.response.data.message))
              }
            }}
            validationSchema={() => emailSchema(messages)}
          >
            {(formikProp) => {
              return (
                <Form>
                  <FormInput
                    field={{
                      type: 'text',
                      className: 'w-full',
                      name: 'email',
                      placeholder: 'Email'
                    }}
                    error={!!formikProp.errors.email && !!formikProp.touched.email}
                  />
                  <button className='w-full bg-primary text-white'>{t('continue')}</button>
                </Form>
              )
            }}
          </Formik>
        </>
      )}
      {step === 1 && (
        <>
          <div className='w-full flex flex-col items-center justify-center'>
            <div className='w-24 h-24 rounded-full bg-gray-500 my-2' />
            <span className='text-center'>{userLogged.email}</span>
          </div>
          <Formik
            initialValues={{
              password: ''
            }}
            onSubmit={async (values) => {
              try {
                // datalayer push submit onsite
                TagManager.dataLayer({
                  dataLayer: {
                    event: 'asyncAction',
                    gaHitType: 'event',
                    category: 'Login',
                    action: 'Login-Submit',
                    label: 'onsite'
                  }
                })
                const { data: res } = await axios.post(`${process.env.REACT_APP_API_PATH}/auth/login`, {
                  email: userLogged.email,
                  password: values.password,
                  from: from,
                })
                window.user = res.data
                setUserLogged({
                  ...res.data
                })
                cookie.save('8egma2jfs9mu', res.data.api_token, {
                  expires: moment().add(7, 'days').toDate(),
                  path: '/'
                })

                localStorage.setItem('user', JSON.stringify(res.data));
                //login success 
                window.location.href = from ? `${ROUTE_LOGIN_SUCCESS}?from=${encodeURIComponent(from)}` : ROUTE_LOGIN_SUCCESS
              } catch (e) {
                //login fail 
                TagManager.dataLayer({
                  dataLayer: {
                    event: 'asyncAction',
                    gaHitType: 'event',
                    category: 'Login',
                    action: 'Login-Fail',
                    label: 'onsite'
                  }
                })
                toast.error(t(e.response.data.message))
              }
            }}
            validationSchema={() => passwordSchema(messages)}
          >
            {(formikProp) => {
              return (
                <Form>
                  <FormInput
                    field={{
                      type: 'password',
                      className: 'w-full',
                      name: 'password',
                      placeholder: 'Password'
                    }}
                    error={!!formikProp.errors.password && !!formikProp.touched.password}
                  />
                  <div className="pt-0 pb-4 text-right">
                    <a onClick={handleClickForgotPassword} className={`text-black cursor-pointer ${forgotPasswordClicked ? 'pointer-events-none' : ''} text-sm`}>{t('forgotPasswordLink')}</a>
                  </div>
                  <button className='w-full bg-primary text-white'>{t('signIn')}</button>
                </Form>

              )
            }}
          </Formik>
        </>
      )}

      <div className='flex flex-col'>
        {/* <a onClick={() => history.push('/recovery-password')} className='text-black font-bold underline cursor-pointer pt-2'>{t('recoverPass')}</a> */}
        {step === 1 && (
          <span className='pt-2'>
            <Trans i18nKey='anotherAccount'>
              Isn't your account? <a onClick={() => {
                setUserLogged({})
                decrementStep()
              }} className='text-black font-bold underline cursor-pointer'>Use another account</a>
            </Trans>
          </span>
        )}
        {step === 0 && (
          <span className='py-2'>
            <Trans i18nKey='notSignUp'>
              Not Signed up? <a onClick={() => history.push((from) ? `${ROUTE_REGISTER}?from=${encodeURIComponent(from)}` : ROUTE_REGISTER)} className='text-black font-bold underline cursor-pointer'>Sign Up here</a>
            </Trans>
          </span>
        )}
      </div>
    </div>
  )
}

export default LoginForm